import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { GroupType, GroupTypePairs, toString as toStringGroupType } from "../../../types/models/GroupType.d";





import { PrimaryMembersGroup } from "../../../../auth/types/models/MembersGroup";

import MembersGroupFormSelect from "../../../../auth/components/membersGroup/MembersGroupForm/MembersGroupFormSelect";

import { PrimaryUser } from "../../../../auth/types/models/User";

import UserFormSelect from "../../../../auth/components/user/UserForm/UserFormSelect";



import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";













export const initialFormStateFn = () => { return {
    
        
        membersGroupId: null,
        
    
        
        ownedMembersGroupId: null,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.membersGroupId = PrimaryMembersGroup.fromQuery(location.state?.membersGroupId) || null;
    initialFormState.ownedMembersGroupId = PrimaryUser.fromQuery(location.state?.userId) || null;
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        membersGroupId:
        string()
                .nanoid(msg`Member Group is required`)
                .min(1, msg`Member Group is required`),
    
    
        ownedMembersGroupId:
        string()
                .nanoid(msg`Owner Member Group is required`)
                .min(1, msg`Owner Member Group is required`),
    
};

export const formSchema = object(formObject);

const MembersGroupUserAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
    
    <MembersGroupFormSelect
        type="none"
        name="membersGroupId"
        label={t`Member Group`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <UserFormSelect
        type="none"
        name="ownedMembersGroupId"
        label={t`Owner Member Group`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
        </Container>
    )
}

export default MembersGroupUserAddForm;
